import Dashboard from "../pages/dashboard/Dashboard";
import DashboardDetail from "../pages/dashboard/DashboardDetail";
import { MarketDefinition } from "../pages/definitions/market/MarketDefinition";
import { BoardDefinition } from "../pages/definitions/board/BoardDefinition";
import { NotConfirmDefinition } from "../pages/definitions/notConfirm/NotConfirmDefinition";
import { RoomDefinition } from "../pages/definitions/room/RoomDefinition";
import { Monitor } from "../pages/monitor/Monitor";
import { routeContants } from "../utils/RouteConstants";
import { OtherAgencyDefinition } from "../pages/definitions/otherAgency/OtherAgencyDefinition";
import { AgencyMarketDefinition } from "../pages/definitions/agency-markets/AgencyMarketDefinition";
import { UserDefinition } from "../pages/definitions/user/UserDefinition";
import Parameters from "../pages/parameters/Parameters";
import { EntryList } from "../pages/entry-list/EntryList";
import UserManual from "../pages/help/user-manual/UserManual";
import News from "../pages/help/user-manual/News";
import ContactUs from "../pages/help/contact-us/ContactUs";
import FAQ from "../pages/help/faq/FAQ";
import { ActionCreate } from "../pages/action/ActionCreate";
import { ActionHistory } from "../pages/action/ActionHistory";
import { ActionReports } from "../pages/action/ActionReports";
import { OfferList } from "../pages/offer/OfferList";
import { TourismNews } from "../pages/tourismNews/TourismNews";
import Agencies from "../pages/agencies/Agencies";
import { PmsIntegrations } from "../pages/pmsIntegration/PmsIntegrations";
import { StopFreeSaleMessage } from "../pages/stop-free-sale/StopFreeSaleMessage";
import { AddUpdateStopFreeSale } from "../pages/stop-free-sale/AddUpdateStopFreeSale";
import { StopFreeSaleReport } from "../pages/stop-free-sale/StopFreeSaleReport";
import { StopFreeSaleCreate } from "../pages/stop-free-sale/StopFreeSaleCreate";
import { StopFreeSaleSended } from "../pages/stop-free-sale/StopFreeSaleSended";
import { FactSheetDashboard } from "../pages/fact-sheet/FactSheetDashboard";
import { Payment } from "../pages/payment/Payment";
import UserAccount from "../pages/account/UserAccount";
import HotelAccount from "../pages/account/HotelAccount";

export const ProtectedRoutes = [
  { path: routeContants.DASHBOARD, Component: <Dashboard /> },
  { path: routeContants.DASHBOARD_DETAIL, Component: <DashboardDetail /> },
  { path: routeContants.RESERVATION_MONITOR, Component: <Monitor /> },
  { path: routeContants.MARKET_DEFINITIONS, Component: <MarketDefinition /> },
  { path: routeContants.BOARD_DEFINITIONS, Component: <BoardDefinition /> },
  { path: routeContants.OTHER_AGENCY_DEFINITIONS, Component: <OtherAgencyDefinition /> },
  { path: routeContants.AGENCY_MARKETS_DEFINITIONS, Component: <AgencyMarketDefinition /> },
  { path: routeContants.USER_DEFINITIONS, Component: <UserDefinition /> },
  { path: routeContants.ROOM_DEFINITIONS, Component: <RoomDefinition /> },
  { path: routeContants.NOTCONFRIM_DEFINITIONS, Component: <NotConfirmDefinition /> },
  { path: routeContants.ENRTRY_LIST, Component: <EntryList /> },
  { path: routeContants.HELP_USERMANUAL_USER_MANUAL, Component: <UserManual /> },
  { path: routeContants.HELP_USERMANUAL_NEWS, Component: <News /> },
  { path: routeContants.HELP_CONTACT_US, Component: <ContactUs /> },
  { path: routeContants.HELP_FAQ, Component: <FAQ /> },
  { path: routeContants.ACTION_CREATE, Component: <ActionCreate /> },
  { path: routeContants.ACTION_HISTORY, Component: <ActionHistory /> },
  { path: routeContants.ACTION_REPORTS, Component: <ActionReports /> },
  { path: routeContants.PARAMETERS, Component: <Parameters /> },
  { path: routeContants.OFFERS, Component: <OfferList /> },
  { path: routeContants.TOURISM_NEWS, Component: <TourismNews /> },
  { path: routeContants.AGENCIES, Component: <Agencies /> },
  { path: routeContants.PMS_INTEGRATIONS, Component: <PmsIntegrations /> },
  { path: routeContants.STOP_FREE_SALE_MESSAGE, Component: <StopFreeSaleMessage /> },
  { path: routeContants.STOP_FREE_SALE_ADD, Component: <AddUpdateStopFreeSale /> },
  { path: routeContants.STOP_FREE_SALE_REPORT, Component: <StopFreeSaleReport /> },
  { path: routeContants.STOP_FREE_SALE_CREATE, Component: <StopFreeSaleCreate /> },
  { path: routeContants.STOP_FREE_SALE_SENDED, Component: <StopFreeSaleSended /> },
  { path: routeContants.STOP_FREE_SALE_SENDED, Component: <StopFreeSaleSended /> },
  { path: routeContants.FACT_SHEET_DASHBOARD, Component: <FactSheetDashboard /> },
  { path: routeContants.PAYMENT, Component: <Payment /> },
  { path: routeContants.USER_ACCOUNT, Component: <UserAccount /> },
  { path: routeContants.HOTEL_ACCOUNT, Component: <HotelAccount /> }
];